import axios from 'axios';
import { BLOCKING_LOCATION } from 'data/geoLocation';

const GEOLOCATION_REQUEST_TIMEOUT_MS = 5000;
const GEOLOCATION_API_URL = 'https://slack-ydfb.vercel.app/api/ip';

export type LocationInfo = {
	ip?: string;
	city?: string;
	region?: string;
	country?: string;
	countryCode: string;
	org?: string;
	capital?: string;
	formattedAddress?: string;
	isProxy?: boolean;
	isBlocked: boolean;
};

const str = (val: unknown): string | undefined => {
	const s = typeof val === 'string' ? val.trim() : undefined;
	return s && s.length > 0 ? s : undefined;
};

const extractCountryCode = (data: unknown): string | null => {
	if (!data || typeof data !== 'object') return null;

	const record = data as Record<string, unknown>;
	const countryCode =
		record.countryCode ?? record.country_code ?? record.country;

	return typeof countryCode === 'string' && countryCode.trim().length > 0
		? countryCode.trim().toUpperCase()
		: null;
};

export const fetchFromIpApi = async (): Promise<LocationInfo> => {
	const res = await axios.get(GEOLOCATION_API_URL, {
		timeout: GEOLOCATION_REQUEST_TIMEOUT_MS,
	});
	const d = res.data as Record<string, unknown>;

	const countryCode = extractCountryCode(d);

	if (!countryCode) {
		throw new Error('Geolocation API did not return a country code');
	}

	return {
		ip: str(d.ip),
		city: str(d.cityName) ?? str(d.city),
		region: str(d.regionName),
		country: str(d.countryName) ?? str(d.country),
		countryCode,
		capital: str(d.capital),
		formattedAddress: str(d.formattedAddress),
		isProxy: typeof d.isProxy === 'boolean' ? d.isProxy : undefined,
		org: str(d.isp) ?? str(d.org),
		isBlocked: BLOCKING_LOCATION.includes(countryCode),
	};
};

export const fetchIpLocationInfo = async (): Promise<LocationInfo | null> => {
	try {
		return await fetchFromIpApi();
		// return await fetchFromBackend();
		// return await fetchFromIpApiCo();
		// return await fetchFromIpWhois();
	} catch {
		return null;
	}
};

export const fetchIpInformation = async (): Promise<boolean> => {
	const info = await fetchIpLocationInfo();
	return info?.isBlocked ?? false;
};
